import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { startTelemetry } from './lib/telemetry';
import './index.css';

// Before the app renders, so a crash during the first paint is still reported.
startTelemetry();

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    {/* Last line of defence: a render error costs a card, never the whole page. */}
    <ErrorBoundary label="app">
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
